var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3, _g4, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarket = function SvgMarket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.652 223.891"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "market_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h19.713v19.713H0z",
    "data-name": "Rectangle 2698"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "market_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h6.942v4.373H0z",
    "data-name": "Rectangle 2699"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "market_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h6.949v1.719H0z",
    "data-name": "Rectangle 2708"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "market_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h6.887v.843H0z",
    "data-name": "Rectangle 2710"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "market_svg__a",
    width: 229.652,
    height: 223.891,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.173
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10032"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10033"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0)",
    className: "market_svg__svg-stoke",
    "data-name": "Path 16565"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.856 189.527a81.6 81.6 0 0 1-16.318-1.644 80.6 80.6 0 0 1-15.198-4.718 81 81 0 0 1-13.753-7.465 81.6 81.6 0 0 1-11.983-9.887 81.6 81.6 0 0 1-9.887-11.983 81 81 0 0 1-7.465-13.753 80.6 80.6 0 0 1-4.717-15.197 81.6 81.6 0 0 1-1.645-16.318c0-8.606 2.396-19.11 6.93-30.377 4.563-11.341 10.982-22.675 18.564-32.774 3.967-5.284 8.198-10.152 12.577-14.47 4.607-4.542 9.382-8.478 14.193-11.697 5.09-3.406 10.26-6.036 15.367-7.816 5.415-1.888 10.833-2.845 16.106-2.845 12.936 0 25.177 5.682 36.384 16.889 12.652 12.652 22.266 23.309 29.392 32.58 3.542 4.607 6.481 8.872 8.988 13.039 2.423 4.03 4.38 7.866 5.983 11.73 6.247 15.06 6.116 28.466 5.936 47.02-.033 3.318-.066 6.748-.066 10.405 0 20.227-9.08 33.736-27.76 41.3-7.742 3.134-17.116 5.271-28.657 6.533-9.037.988-19.514 1.448-32.971 1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "M104.627 9.083c-5.216 0-10.58.948-15.942 2.817-5.067 1.766-10.199 4.377-15.253 7.76-4.785 3.201-9.535 7.117-14.12 11.638-4.361 4.3-8.576 9.15-12.528 14.413-7.556 10.065-13.953 21.36-18.5 32.66-2.22 5.516-3.938 10.893-5.107 15.982-1.186 5.16-1.787 9.941-1.787 14.209 0 5.46.55 10.917 1.635 16.218a80 80 0 0 0 4.688 15.102 80.5 80.5 0 0 0 7.419 13.668 81 81 0 0 0 9.826 11.91 81 81 0 0 0 11.91 9.826 80.5 80.5 0 0 0 13.667 7.418 80 80 0 0 0 15.103 4.689 81 81 0 0 0 16.218 1.634c13.438 0 23.898-.459 32.917-1.445 11.494-1.257 20.824-3.383 28.524-6.5 4.255-1.723 8.051-3.783 11.282-6.123 3.416-2.473 6.322-5.347 8.637-8.54 2.439-3.365 4.307-7.2 5.552-11.4 1.311-4.422 1.976-9.393 1.976-14.773 0-3.659.033-7.09.066-10.41.18-18.494.31-31.857-5.898-46.824-1.593-3.84-3.539-7.655-5.95-11.663-2.496-4.15-5.426-8.4-8.955-12.993-7.113-9.253-16.713-19.894-29.35-32.53-11.11-11.11-23.231-16.743-36.03-16.743m0-1c12.206 0 24.704 5.002 36.737 17.035 55.474 55.474 50.38 70.136 50.38 115.128s-44.896 49.781-89.888 49.781-81.466-36.473-81.466-81.465c0-35.233 40.173-100.479 84.237-100.479"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#market_svg__a)",
    transform: "translate(0 .004)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M107.883 22.501c31.657 0 52.156 17.307 68.756 48.136 10.476 19.454 31.305 46.53 30.489 72.753-2.081 66.893-99.225 61.031-130.147 53.774S9.086 147.501 27.36 102.859s28.455-80.358 80.523-80.358",
    "data-name": "Path 16564"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9332"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9735"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9330"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9734"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ddd",
    d: "M45.593 163.022h150.281v.824H45.593z",
    "data-name": "Rectangle 2697"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "m128.047 123.746-11.5 9.319-11.852-13.519-31.075 25.6 6.36 7.846 23.733-19.24 11.811 13.152 18.884-15.308Z",
    "data-name": "Path 14889"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4b2ba",
    d: "m138.052 137.679-15.191-18.816 21.639-1.929Z",
    "data-name": "Path 14890"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.884 86.916h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.552c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.55c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232",
    "data-name": "Path 14891"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.884 92.282h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.552c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.55c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232",
    "data-name": "Path 14892"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.884 97.923h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.552c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.55c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232",
    "data-name": "Path 14893"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.884 103.289h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.552c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.55c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232",
    "data-name": "Path 14894"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.884 108.857h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.552c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.55c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232",
    "data-name": "Path 14895"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.884 114.222h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.552c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.55c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232",
    "data-name": "Path 14896"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M141.884 119.79h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.552c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.55c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232m-8.24 0h-4.557c-.238 0-.431-.1-.431-.232s.193-.232.431-.232h4.557c.238 0 .431.1.431.232s-.193.232-.431.232",
    "data-name": "Path 14897"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "m97.612 112.657-15.23-16.53-9.032 7.742.065-1.014 9.026-7.737 15.062 16.344 13.442-21.315 7.266 10.361 11.167-18.814.626.372-11.742 19.784-7.285-10.388Z",
    "data-name": "Path 14898"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "m130.609 84.137-1.249-1.7-2.091-.282 4.019-2.967Z",
    "data-name": "Path 14899"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "m99.466 119.088-12.745-8.084-8.444 5.075-.728.438-.13-.771 4.587-2.757 4.725-2.84 12.74 8.081 14.293-8.8 5.131 7.087 11.458-24.312.659.31-11.983 25.427-5.458-7.538Z",
    "data-name": "Path 14900"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "m131.811 94.523-1.4-1.574-2.108-.082 3.718-3.335Z",
    "data-name": "Path 14901"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#61a3c5",
    d: "M83.639 95.624a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14903"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#61a3c5",
    d: "M98.641 112.06a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14904"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#49263e",
    d: "M87.766 110.749a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14905"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#49263e",
    d: "M97.605 118.167a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14907"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#49263e",
    d: "M111.73 110.163a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14908"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#49263e",
    d: "M117.097 117.202a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14909"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#61a3c5",
    d: "M109.09 90.969a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14910"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#61a3c5",
    d: "M116.446 101.09a1.083 1.083 0 1 1-1.083-1.083 1.083 1.083 0 0 1 1.083 1.083",
    "data-name": "Path 14911"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffad8d",
    d: "M162.277 96.693s-.893 6.292-1.709 7.72-13.9 6.284-13.9 6.284l-1.586-4.006 10-5.676 1.954-5.437Z",
    "data-name": "Path 14912"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffad8d",
    d: "m142.641 107.688-.134-.04c-.263.132-.807.364-1.427.669.225.538.385.96.324 1l.064.111a.12.12 0 0 1 .012.09c.292.518.679 1.167.967 1.731.2.4.247.809.676.872a5.7 5.7 0 0 0 1.619-.6l2.447-1.044c-.383-.689-1.112-4.2-1.283-4.247Z",
    "data-name": "Path 14913"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffad8d",
    d: "m144.316 107.721-1.311.9-.627.442-.249.026-.341-.28-.084-.44.244-.337 1.159-1.157 1.255.236Z",
    "data-name": "Path 14914"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M144.144 108.057a.11.11 0 0 0-.026-.116.09.09 0 0 0-.124-.023l-1.555 1.092a.377.377 0 0 1-.522-.072.56.56 0 0 1-.163-.309.3.3 0 0 1 .075-.271l1.245-1.215a.1.1 0 0 0-.016-.129.09.09 0 0 0-.123-.024l-1.245 1.215a.45.45 0 0 0-.11.4.82.82 0 0 0 .237.452.55.55 0 0 0 .76.11l1.555-1.092.01-.013",
    "data-name": "Path 14915"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    d: "m143.718 103.984-1.691.673-.111.044-1.691.673 6.306 19.741a1.006 1.006 0 0 0 1.33.628l4.3-1.712a1.006 1.006 0 0 0 .535-1.37Z",
    "data-name": "Path 14916"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a99af",
    d: "m143.906 104.379-3.575 1.423a.77.77 0 0 1-1-.432l-.464-1.166a.6.6 0 0 1 .337-.783l3.89-1.548a.6.6 0 0 1 .783.337l.464 1.166a.77.77 0 0 1-.432 1",
    "data-name": "Path 14917"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "m143.163 104.771-2.727 1.085a.94.94 0 0 1-1.22-.526l-.658-1.653.167-.066.658 1.653a.76.76 0 0 0 .988.425l2.727-1.085Z",
    "data-name": "Path 14918"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9319",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9318"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#market_svg__b)",
    "data-name": "Group 9317",
    transform: "translate(127.56 83.526)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d4eef4",
    d: "M19.012 6.214A9.854 9.854 0 1 1 6.212.701a9.854 9.854 0 0 1 12.8 5.513",
    "data-name": "Path 14919"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9322",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9321"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#market_svg__c)",
    "data-name": "Group 9320",
    transform: "translate(136.262 85.452)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f3fffe",
    d: "M6.873 3.65c-.386.9-2.221.968-4.1.159S-.313 1.618.073.721s2.221-.968 4.1-.159 3.086 2.191 2.7 3.088",
    "data-name": "Path 14920"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "m140.312 105.802.17-.054 6.226 19.601-.171.054z",
    "data-name": "Rectangle 2700"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "m129.563 90.046-.172-.049a6.8 6.8 0 0 1 2.43-3.375l.1.149a6.6 6.6 0 0 0-2.357 3.275",
    "data-name": "Path 14921"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "m130.497 90.866-.172-.049a6.8 6.8 0 0 1 2.43-3.375l.1.149a6.6 6.6 0 0 0-2.357 3.275",
    "data-name": "Path 14922"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    d: "M128.261 97.026a9.854 9.854 0 1 1 12.8 5.513 9.854 9.854 0 0 1-12.8-5.513m13.378 6.969a11.421 11.421 0 1 0-14.834-6.389 11.42 11.42 0 0 0 14.834 6.389",
    "data-name": "Path 14923"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M141.673 104.078a11.511 11.511 0 1 1 .053-21.369l-.067.166a11.331 11.331 0 1 0 6.027 15.3l.162.076a11.47 11.47 0 0 1-6.175 5.827",
    "data-name": "Path 14924"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#33192c",
    d: "M161.769 78.897a2.62 2.62 0 0 1 .394-3.323c1.539-1.856 2.436.414 3.222.449s2.041-.56 2.871.684.8 2.316 1.628 2.338 3.836 1.352 3.817 4.079a3.225 3.225 0 0 1-2.552 3.2s-9.706 2.83-11 .441-.613-3.725.42-4.893c.635-.718 2.064-1.535 1.2-2.978",
    "data-name": "Path 14925"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffad8d",
    d: "M140.371 109.59a.51.51 0 0 0 .466.322l1.531-.723a.45.45 0 0 0 .136-.609c-.126-.28-.4-.432-.6-.338l-1.525.72a.8.8 0 0 0-.006.628",
    "data-name": "Path 14926"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffad8d",
    d: "M140.789 110.439c.146.3.406.457.456.435l1.672-.737a.444.444 0 0 0 .147-.6c-.122-.282-.4-.439-.6-.35l-1.715.755a.57.57 0 0 0 .039.5",
    "data-name": "Path 14927"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffad8d",
    d: "M141.409 111.301c.133.276.375.43.422.41l1.569-.662a.41.41 0 0 0 .144-.557c-.112-.263-.367-.413-.558-.333l-1.61.679a.53.53 0 0 0 .032.464",
    "data-name": "Path 14928"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M140.75 110.054a.1.1 0 0 1-.1-.062.086.086 0 0 1 .021-.119l1.653-.771a.366.366 0 0 0 .113-.5.54.54 0 0 0-.222-.251.29.29 0 0 0-.268-.023l-1.509.713a.093.093 0 0 1-.111-.058.086.086 0 0 1 .021-.119l1.509-.713a.43.43 0 0 1 .392.034.8.8 0 0 1 .324.367.534.534 0 0 1-.16.722l-1.654.771h-.015",
    "data-name": "Path 14929"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffad8d",
    d: "M139.959 108.52c.141.3.408.454.458.432l1.662-.751a.44.44 0 0 0 .152-.591c-.12-.291-.4-.453-.607-.36l-1.551.7c-.172.078-.2.4-.114.57",
    "data-name": "Path 14930"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M140.441 109.038a.1.1 0 0 1-.1-.064.085.085 0 0 1 .022-.119l1.667-.744a.36.36 0 0 0 .118-.492.54.54 0 0 0-.22-.253.3.3 0 0 0-.268-.027l-1.522.688a.094.094 0 0 1-.11-.059.085.085 0 0 1 .022-.119l1.522-.688a.43.43 0 0 1 .393.04.8.8 0 0 1 .321.37.53.53 0 0 1-.168.718l-1.667.744h-.015",
    "data-name": "Path 14931"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M141.303 110.893a.1.1 0 0 1-.1-.065c-.024-.049-.013-.1.024-.117l1.644-.688a.33.33 0 0 0 .119-.465.54.54 0 0 0-.218-.255.3.3 0 0 0-.269-.03l-1.715.755a.093.093 0 0 1-.11-.06.085.085 0 0 1 .023-.118l1.715-.755a.44.44 0 0 1 .393.043.8.8 0 0 1 .319.372.5.5 0 0 1-.171.691l-1.646.688h-.013",
    "data-name": "Path 14932"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M141.844 111.736a.1.1 0 0 1-.1-.065c-.024-.049-.013-.1.024-.118l1.57-.662a.327.327 0 0 0 .117-.446.5.5 0 0 0-.2-.235.27.27 0 0 0-.246-.031l-1.61.679a.094.094 0 0 1-.11-.061c-.024-.049-.013-.1.024-.118l1.61-.679a.41.41 0 0 1 .371.046.75.75 0 0 1 .3.354.49.49 0 0 1-.17.669l-1.57.662h-.013",
    "data-name": "Path 14933"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M162.982 79.449a2.2 2.2 0 0 1 1.9-1.887c1.843-.448 2.315.912 2.315.912l-2.063.768-2.015.175Z",
    "data-name": "Path 14934"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "m165.925 122.349-1.88 16.89.622 4.029a39 39 0 0 1 .433 7.225l-.32 9.492-5.59.264-4.348-39.361Z",
    "data-name": "Path 14935"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "m167.166 122.349 4.439 16.88 5.458 20.756 5.864.566-5.018-39.666Z",
    "data-name": "Path 14936"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#33182c",
    d: "M177.002 161.975h4.979l2.019-2.2 3.693 2.2h.8a.58.58 0 0 1 .577.454.567.567 0 0 1-.556.679h-11.578a.154.154 0 0 1-.154-.154v-.754a.225.225 0 0 1 .225-.225",
    "data-name": "Path 14937"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "M177.045 161.981v-2.044a1.77 1.77 0 0 1 2.115-.553 2.87 2.87 0 0 0 3.634-.288l4.228 1.875s1.159.387 1.473 1.009Z",
    "data-name": "Path 14938"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M177.003 159.938h.085v2.034h-.085z",
    "data-name": "Rectangle 2701"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M180.892 159.96a2 2 0 0 0 .262-.014l-.012-.084a3 3 0 0 1-1.957-.512l-.048.07a3.13 3.13 0 0 0 1.755.54",
    "data-name": "Path 14939"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m177.534 161.236.047-.07.54.363-.047.07z",
    "data-name": "Rectangle 2702"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m177.921 161.133.048-.07.54.363-.048.07z",
    "data-name": "Rectangle 2703"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M188.903 163.011a.609.609 0 0 0-.394-1.073h-11.448a.327.327 0 0 0-.326.327v.565h.085v-.565a.24.24 0 0 1 .241-.242h11.448a.524.524 0 0 1 .339.924Z",
    "data-name": "Path 14940"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m188.469 161.998.077-.036a2.1 2.1 0 0 0-1.107-.864c-.85-.363-4.591-2.022-4.628-2.038l-.035.078c.038.017 3.779 1.676 4.63 2.039a2.06 2.06 0 0 1 1.063.823",
    "data-name": "Path 14941"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#33182c",
    d: "M164.876 161.975h-4.98l-2.018-2.2-3.693 2.2h-.8a.58.58 0 0 0-.577.454.567.567 0 0 0 .556.679h11.578a.154.154 0 0 0 .154-.154v-.754a.225.225 0 0 0-.225-.225",
    "data-name": "Path 14942"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "M164.828 161.981v-2.044a1.77 1.77 0 0 0-2.115-.553 2.87 2.87 0 0 1-3.634-.288l-4.228 1.875s-1.159.387-1.473 1.009Z",
    "data-name": "Path 14943"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M164.785 159.938h.085v2.034h-.085z",
    "data-name": "Rectangle 2704"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M160.981 159.96a2 2 0 0 1-.262-.014l.013-.084a3 3 0 0 0 1.957-.512l.048.07a3.13 3.13 0 0 1-1.755.54",
    "data-name": "Path 14944"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m163.751 161.53.54-.363.048.07-.54.364z",
    "data-name": "Rectangle 2705"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m163.364 161.427.54-.364.047.07-.54.364z",
    "data-name": "Rectangle 2706"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M152.971 163.011a.609.609 0 0 1 .394-1.073h11.451a.327.327 0 0 1 .327.327v.565h-.085v-.565a.24.24 0 0 0-.242-.242h-11.448a.525.525 0 0 0-.339.924Z",
    "data-name": "Path 14945"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m153.403 161.998-.077-.036a2.1 2.1 0 0 1 1.107-.864c.851-.363 4.591-2.022 4.628-2.038l.035.078c-.038.017-3.778 1.676-4.63 2.039a2.06 2.06 0 0 0-1.063.823",
    "data-name": "Path 14946"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#f23346",
    d: "M161.743 85.622a4.01 4.01 0 0 0-2.875 1.866c-1.185 1.567-3.787 13.528-3.787 13.528l-9.74 5.27a18.4 18.4 0 0 0 2.223 4.382s12.83-5.129 12.875-5.28 1.432-5.723 1.351-6.176-.047-13.591-.047-13.591",
    "data-name": "Path 14947"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M185.685 102.79c.015-1.046-2.65-5.639-3.721-7.646a19.3 19.3 0 0 1-5.161 3.031c1.061 1.692 2.276 3.9 2.779 4.689.522.817-1.533 7.29-2.26 8.531l2.615 3.032c1.812-1.664 5.7-8.02 5.748-11.638",
    "data-name": "Path 14948"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M162.982 79.45s.031 3.693.764 4.4a1.27 1.27 0 0 0 1.075.28l.356 2.258 3.186-.5-1.163-7.413Z",
    "data-name": "Path 14949"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M164.469 82.119a.029.029 0 0 0 0-.058c-.193-.011-.347-.222-.393-.292a.88.88 0 0 0 .4-.624.96.96 0 0 0-.262-.679.03.03 0 0 0-.042.041.91.91 0 0 1 .246.634.84.84 0 0 1-.393.6l-.021.016.013.023c.008.013.193.329.455.343h.006",
    "data-name": "Path 14950"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "m164.966 85.047-.141-.918a6.3 6.3 0 0 0 2.313-1.191 8.3 8.3 0 0 1-2.172 2.109",
    "data-name": "Path 14951"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#33192c",
    d: "M166.006 80.303a.06.06 0 0 0 .037-.023.06.06 0 0 0-.011-.082c-.008-.007-.873-.65-1.466.005a.059.059 0 1 0 .087.079c.521-.575 1.276-.015 1.308.01a.06.06 0 0 0 .045.011",
    "data-name": "Path 14952"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#33192c",
    d: "M163.962 80.343a.06.06 0 0 0 .03-.038.06.06 0 0 0-.043-.071c-.028-.007-.7-.163-.863.242a.059.059 0 1 0 .109.044c.126-.311.72-.173.726-.172a.06.06 0 0 0 .041 0",
    "data-name": "Path 14953"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M163.376 81.055a.164.164 0 1 0 .136-.187.164.164 0 0 0-.136.187",
    "data-name": "Path 14954"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M165.033 80.793a.164.164 0 1 0 .136-.187.163.163 0 0 0-.136.187",
    "data-name": "Path 14955"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M166.974 81.196a.918.918 0 1 0 .764-1.05.92.92 0 0 0-.764 1.05",
    "data-name": "Path 14956"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M168.04 81.602a.39.39 0 0 0 .314-.342.36.36 0 0 0-.211-.4.43.43 0 0 0-.469.084.4.4 0 0 1 .144-.238.57.57 0 0 1 .4-.088.03.03 0 0 0 .034-.024.03.03 0 0 0-.024-.034.62.62 0 0 0-.441.1.5.5 0 0 0-.18.37l-.01.1.062-.085a.4.4 0 0 1 .465-.135.31.31 0 0 1 .175.334.325.325 0 0 1-.27.293.03.03 0 0 0 .008.058h.005",
    "data-name": "Path 14957"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#33192c",
    d: "M162.659 79.163a4.37 4.37 0 0 0 2.788-.245s.974 1.668 2.018 1.3-.205-2.707-.205-2.707-2.1-.789-2.229-.755-2.383.987-2.383.987Z",
    "data-name": "Path 14958"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M164.833 81.353a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14959"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M165.072 81.448a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14960"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M165.427 81.126a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14961"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M165.808 81.332a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14962"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M166.109 80.927a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14963"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M166.32 81.425a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14964"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M164.079 81.256a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14965"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M163.858 81.588a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14966"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M163.513 81.511a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14967"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M163.569 82.025a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14968"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M163.279 81.763a.036.036 0 0 0-.012-.072.036.036 0 0 0 .012.072",
    "data-name": "Path 14969"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M163.266 81.309a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14970"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea5942",
    d: "M165.365 81.634a.036.036 0 0 0-.011-.072.036.036 0 0 0 .011.072",
    "data-name": "Path 14971"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "M153.527 128.675a14.6 14.6 0 0 0 .317 4.046c13.757 7.1 29.351-1.193 29.351-1.193a82.4 82.4 0 0 0-5.39-20.07c-.247-.572-1.139-2.886-2.1-4.923-.847-1.787-1.786-3.339-1.9-3.608-.146-.338-.518-.617-.479-.874.052-.338 1.272-3.212 2.208-5.891l4.135 7.039a52 52 0 0 0 5.861-2.116c-3.129-5.712-7.292-12.075-9.487-14.216-1.932-1.329-5.871-1.687-7.827-1.5a32.5 32.5 0 0 0-6.468.253c-.389.468-3.261 4.9-3.653 5.781a4.64 4.64 0 0 0 .333 4.116c.488.3.55 6.293.638 6.726-4.138 7.7-5.628 17.755-5.533 26.431",
    "data-name": "Path 14972"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M174.809 87.87a.06.06 0 0 1-.05-.025 3.64 3.64 0 0 0-1.587-1.126.062.062 0 0 1 .038-.118 3.7 3.7 0 0 1 1.648 1.17.06.06 0 0 1-.012.087.06.06 0 0 1-.037.012",
    "data-name": "Path 14973"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M174.692 88.444a.06.06 0 0 1-.049-.025 3.64 3.64 0 0 0-1.588-1.126.062.062 0 1 1 .038-.118 3.7 3.7 0 0 1 1.648 1.17.06.06 0 0 1-.012.087.06.06 0 0 1-.037.012",
    "data-name": "Path 14974"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M171.693 102.318h.008l1.6-.17a.074.074 0 0 0 .066-.082.073.073 0 0 0-.082-.066l-1.6.17a.074.074 0 0 0 .008.148",
    "data-name": "Path 14975"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M153.675 132.707a.074.074 0 0 0 .069-.079 66.1 66.1 0 0 1 2.222-22.645 33.4 33.4 0 0 1 3.151-7.7l.013-.021v-.025l-.479-6.489-.01-.016a4.624 4.624 0 0 1 .431-5.756.074.074 0 1 0-.105-.1 4.77 4.77 0 0 0-.46 5.926l.475 6.427a34 34 0 0 0-3.152 7.708 66.2 66.2 0 0 0-2.23 22.7.074.074 0 0 0 .074.069",
    "data-name": "Path 14976"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "m174.928 97.926-1.548 4.14c.381.61 6.029 9.826 9.013 24.908a.074.074 0 0 1-.058.087h-.014a.074.074 0 0 1-.073-.06c-3.068-15.507-8.954-24.8-9.013-24.888l-.02-.031 1.6-4.276Z",
    "data-name": "Path 14977"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M176.895 111.308a8 8 0 0 1-1.347-.568c-.635-.352-.662.207-.55.426a9 9 0 0 0 .812.948Z",
    "data-name": "Path 14978"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M177.683 110.626c-.01.019-.342.6-.352.62-1.031.146-2.231.315-2.526.354a7.4 7.4 0 0 0-2.766 1.469c-.885.993-.253.957-.253.957-.823 1.117.194.935.194.935-.824.936.166.95.166.95-.391.548-.256.763-.076.848a.46.46 0 0 0 .414-.019c.236-.128.754-.411 1.293-.717a49 49 0 0 1 4.926-1.217l1.235-.379Z",
    "data-name": "Path 14979"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M173.192 115.051a.066.066 0 0 1 .046.121 8 8 0 0 0-1.048.789.067.067 0 0 1-.088-.1 8 8 0 0 1 1.071-.805l.019-.007",
    "data-name": "Path 14980"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M173.023 114.235a.066.066 0 0 1 .038.125 4 4 0 0 0-1.037.65.067.067 0 0 1-.088-.1 4.1 4.1 0 0 1 1.075-.674h.012",
    "data-name": "Path 14981"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M172.687 113.336a.066.066 0 0 1 .04.124 3.5 3.5 0 0 0-.9.613.066.066 0 0 1-.092-.094 3.6 3.6 0 0 1 .934-.639h.014",
    "data-name": "Path 14982"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff424d",
    d: "M185.523 101.086a5.7 5.7 0 0 1 .162 3.382c-.462 1.992-2.379 7.261-5.16 9.625a23.5 23.5 0 0 1-2.912-3.894s2.161-6.966 2.1-7.88 2.677-1.947 2.677-1.947Z",
    "data-name": "Path 14983"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1eeec",
    d: "M170.668 85.379s-6.808 7.928-7.269 8.9c0 0-.15-6.473-.405-8.838a28.4 28.4 0 0 1 7.675-.067",
    "data-name": "Path 14984"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8d9d1",
    d: "m169.029 85.237-.95-1.161-2.131 1.435-.971-.4-.328 1.046 1.2.613.27-.578.488.582Z",
    "data-name": "Path 14985"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#f23346",
    d: "M170.668 85.379a29 29 0 0 1-1.342 3.919l-1.927.952.035 1.5-4.035 2.53s4.878-6.736 7.269-8.9",
    "data-name": "Path 14986"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#f23346",
    d: "m176.278 108.022-12.175 4.263-2.28-3.082-2.155 2.911-3.377-3.176 3.3 4.4 2.23-2.479 2.242 2.857Z",
    "data-name": "Path 14987"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "m159.677 112.203 2.195-2.965-.1-.071-2.115 2.856-3.327-3.13-.082.087Z",
    "data-name": "Path 14988"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#f23346",
    d: "m158.645 95.733 9.752.629-9.687.121Z",
    "data-name": "Path 14989"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m164.081 112.356.042-.015 12.175-4.263-.04-.113-12.133 4.248-2.24-3.027 1.572-14.88c.242-.336 4.99-6.908 7.251-8.882l-.079-.09c-2.319 2.025-7.229 8.846-7.279 8.915l-.009.013v.016l-1.578 14.942Z",
    "data-name": "Path 14990"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "m167.139 84.499-.042.238-1.149.773-.971-.4c.056.023 2.162-.611 2.162-.611",
    "data-name": "Path 14991"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M164.225 82.514h.007a2.7 2.7 0 0 1 .708-.014c.012 0 .026-.012.029-.031s0-.036-.017-.036a2.8 2.8 0 0 0-.718.015.04.04 0 0 0-.025.038q0 .023.015.029",
    "data-name": "Path 14992"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#f23346",
    d: "M162.994 85.446s-1.121 2.623-1.171 3l.655 1.387-.517.82 1.438 3.633s-.073-6.8-.405-8.838",
    "data-name": "Path 14993"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M163.339 94.284h.12c0-.058-.053-5.789-.406-8.844l-.119.014c.353 3.049.4 8.774.4 8.831",
    "data-name": "Path 14994"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "m58.821 161.762-4.295.059-.062-4.051 4.278-.535Z",
    "data-name": "Path 14996"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "m51.428 161.762-4.295.059-.062-4.051 4.278-.535Z",
    "data-name": "Path 15001"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M33.39 159.343",
    "data-name": "Path 15004"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd7583",
    d: "M45.593 113.834c.173 0 7.019 3.228 7.019 3.228l-1.492 2.631-3.87-.989Z",
    "data-name": "Path 15006"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#fec786",
    d: "m50.905 116.663-.108.836.889-.3-.012-.6Z",
    "data-name": "Path 15014"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "m59.722 110.66-7.616-.5a.517.517 0 0 0-.58.424l-.917 6.979.189-.066.886-6.882a.366.366 0 0 1 .421-.292l7.616.5a.075.075 0 0 0 .08-.076.087.087 0 0 0-.079-.087",
    "data-name": "Path 15015"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd7583",
    d: "M49.558 116.848s.781 2.034.023 6.033l-.759-2.873-1.265-1.872Z",
    "data-name": "Path 15016"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.1 97.124a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15033"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.335 97.115a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15034"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.044 97.582a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15035"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M36.664 97.299a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15036"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.036 97.264a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15037"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.477 97.418a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15038"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.715 97.043h.006v-.018l-.006-.006h-.023v.018l.007.007h.013",
    "data-name": "Path 15039"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M38.08 97.188a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15040"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M38.024 96.936a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15041"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M38.402 96.701a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15042"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M38.659 96.87a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15043"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M38.981 96.801a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15044"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M39.085 97.101a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15045"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M39.364 97.015a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15046"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M39.244 96.826a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15047"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M38.91 97.105a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15048"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M39.028 97.38a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15049"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.019 96.811a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15050"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#f75553",
    d: "M37.856 97.442a.017.017 0 0 0-.011-.032.017.017 0 0 0 .011.032",
    "data-name": "Path 15051"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10031"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b1c25",
    d: "M45.117 93.06a1.4 1.4 0 0 0-.448.026 1.53 1.53 0 0 0-.716.571 2.8 2.8 0 0 0-.736 1.318c-.07.49.1 1.063-.22 1.438a1.5 1.5 0 0 1-.465.312q-.349.179-.68.389a1.3 1.3 0 0 0-.342.28 1.4 1.4 0 0 0-.222.576l-.232 1.035a1.4 1.4 0 0 0-.047.594 1.26 1.26 0 0 0 .881.8 2.54 2.54 0 0 1 1.088.568 4.4 4.4 0 0 1 .46.908 2.26 2.26 0 0 0 1.163 1 4.1 4.1 0 0 0 1.533.261 1.1 1.1 0 0 0 .44-.062 1.2 1.2 0 0 0 .3-.207 4.23 4.23 0 0 0 2.127-3.36l.49-3.514a2 2 0 0 0-.135-1.229c-.124-.357-.248-.715-.4-1.061a1.7 1.7 0 0 0-.374-.587.68.68 0 0 0-.645-.179c-.241.077-.415.328-.668.345a2.3 2.3 0 0 0-.556 0 .6.6 0 0 1-.413.041 4.6 4.6 0 0 0-1.186-.258",
    "data-name": "Path 14995"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eb6573",
    d: "M62.398 162.491h-8.769v-1.765a1.356 1.356 0 0 1 1.609-.415 2.15 2.15 0 0 0 2.733-.2l3.247 1.394s1.181.388 1.181.988",
    "data-name": "Path 14997"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472a31",
    d: "M53.629 163.108h9.032a.12.12 0 0 0 .118-.118v-.381a.12.12 0 0 0-.118-.119h-9.032Z",
    "data-name": "Path 14998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7e4f7",
    d: "m58.932 160.521-1.261 1.97h-.6l1.39-2.171Z",
    "data-name": "Path 14999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7e4f7",
    d: "M58.63 162.491h-.6l1.183-1.848.469.2-1.054 1.647",
    "data-name": "Path 15000"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b0e18",
    d: "M51.049 126.7c.142 4.183.761 20.545 2.061 31.251a1.4 1.4 0 0 0 1.395 1.236 10.8 10.8 0 0 0 3.094-.466 1.41 1.41 0 0 0 1-1.325l.529-32.574a1.4 1.4 0 0 0-.016-.236l-.025-.161a1.406 1.406 0 0 0-1.894-1.1l-5.246 2.015a1.405 1.405 0 0 0-.9 1.36",
    "data-name": "Path 15002"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c222e",
    d: "M45.28 125.856s-.357 20.12.574 32.531a1.19 1.19 0 0 0 1.1 1.1 10.7 10.7 0 0 0 3.525-.325 1.19 1.19 0 0 0 .88-1.046l2.49-28.855 1.533-8.012Z",
    "data-name": "Path 15003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd7583",
    d: "M43.678 119.453c.088.8.569 12.728 1.907 13.712s14.139.038 14.437-1.124-1.439-13.624-1.439-13.624Z",
    "data-name": "Path 15005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd7583",
    d: "M45.427 101.94c1.578-.622 6.308-.65 6.308-.65s.582.174.4.081c4.863 1.031 5.28 4.677 5.28 4.677l2.031 10.565 2.653.235c.8 1.659.023 6.033.023 6.033L49.2 123.893s-2.8.364-5.049-2.734c-1.489-2.05-1.809-8.2-1.656-12.677 0 0-.493-5.19 2.934-6.542",
    "data-name": "Path 15007"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M49.434 116.454a.1.1 0 0 0 .047 0 .08.08 0 0 0 .064-.1c-.012-.058-1.162-5.823-1.612-9.441a.081.081 0 1 0-.161.02c.451 3.624 1.6 9.395 1.614 9.453a.08.08 0 0 0 .048.059",
    "data-name": "Path 15008"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M57.409 116.589a.081.081 0 0 1-.135-.056c0-.067-.388-6.7-.776-8.9a.081.081 0 1 1 .16-.028c.39 2.206.774 8.848.778 8.915a.08.08 0 0 1-.027.066",
    "data-name": "Path 15009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M47.265 115.837h.011l2.157.571a.081.081 0 0 0 .042-.157l-2.157-.571a.081.081 0 0 0-.052.154",
    "data-name": "Path 15010"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M61.26 115.279a.081.081 0 0 0 .064-.149l-2.314-1.014a.08.08 0 0 0-.107.042.08.08 0 0 0 .042.107l2.317 1.017",
    "data-name": "Path 15011"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fec786",
    d: "m70.866 122.976-7.616-.5a.647.647 0 0 1-.624-.657l1.517-11.216a.44.44 0 0 1 .5-.358l7.616.5a.65.65 0 0 1 .624.657l-1.516 11.216a.44.44 0 0 1-.5.358",
    "data-name": "Path 15012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M67.174 120.624a.41.41 0 0 0-.382-.407l-1.295-.087a.1.1 0 0 1 0-.19l1.917-.127a.316.316 0 0 0 .3-.413.51.51 0 0 0-.5-.36l-1.954.129a.1.1 0 0 1-.1-.07l-.008-.031a.1.1 0 0 1 .067-.117l2.1-.563a.41.41 0 0 0 .3-.473.39.39 0 0 0-.484-.289l-2.111.567a.1.1 0 0 1-.117-.067l-.027-.1a.1.1 0 0 1 .056-.113l1.874-.776a.41.41 0 0 0 .232-.508.39.39 0 0 0-.534-.226s-2.882 1.02-3.352 1.144l.867-.405c.638.6-.082-.218-.607-.324-.582-.117-2.118 1.305-2.118 1.305a.78.78 0 0 0 .113.6 32 32 0 0 0 .685 3.226l2.368-.722a5.9 5.9 0 0 1 2.111-.243l.179.012a.393.393 0 0 0 .418-.378",
    "data-name": "Path 15013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M46.623 116.43a.1.1 0 0 0 .031.006c.116 0 11.63.047 15.382.486a10.1 10.1 0 0 1 .267 3.872.081.081 0 0 0 .162.014 9.6 9.6 0 0 0-.293-3.991l-.018-.045-.048-.006c-3.708-.445-15.334-.493-15.451-.493a.081.081 0 0 0-.032.156",
    "data-name": "Path 15017"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M51.319 123.62c4.7 0 10.456-.607 10.811-.645a.1.1 0 0 0 .084-.1.094.094 0 0 0-.1-.084c-.128.014-12.864 1.356-16.063.1-3.162-1.24-3.382-8.2-3.384-8.275a.095.095 0 0 0-.19.005c.008.292.226 7.161 3.5 8.447a17.6 17.6 0 0 0 5.341.554",
    "data-name": "Path 15018"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd7583",
    d: "m46.349 104.467 1.574-2.64 2.766.835 1.122-1.193s.239 1.1.232 1.193a7.2 7.2 0 0 1-1.425 1.383c-.161-.014-4.268.421-4.268.421",
    "data-name": "Path 15019"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd7583",
    d: "M55.003 162.491h-8.769v-1.765a1.356 1.356 0 0 1 1.609-.415 2.15 2.15 0 0 0 2.733-.2l3.247 1.394s1.181.388 1.181.988",
    "data-name": "Path 15021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#683d46",
    d: "M46.234 163.108h9.032a.12.12 0 0 0 .119-.118v-.381a.12.12 0 0 0-.119-.119h-9.032Z",
    "data-name": "Path 15022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7e4f7",
    d: "m51.535 160.521-1.261 1.97h-.6l1.39-2.171Z",
    "data-name": "Path 15023"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7e4f7",
    d: "M51.235 162.491h-.6l1.183-1.848.469.2-1.054 1.647",
    "data-name": "Path 15024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572634",
    d: "M52.092 97.783c.966-.272 1.819-5.688-2.918-5.533 0 0-.222 2.634-.219 2.764s3.137 2.77 3.137 2.77",
    "data-name": "Path 15025"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M51.288 93.988s1.927 4.353-.18 5.777l.366 2.595-3.17.017-.99-7.386s.673-1.936.683-1.86 3.292.858 3.292.858",
    "data-name": "Path 15026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M50.926 97.545a.029.029 0 0 1-.013-.055c.177-.063.261-.3.284-.38a.86.86 0 0 1-.54-.47.93.93 0 0 1 .055-.7.028.028 0 0 1 .05.027.89.89 0 0 0-.052.657.82.82 0 0 0 .531.446l.024.008-.006.025c0 .015-.088.359-.327.445h-.006",
    "data-name": "Path 15027"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "m51.226 100.649-.118-.883a6.1 6.1 0 0 1-2.5-.342 7.6 7.6 0 0 0 2.617 1.226",
    "data-name": "Path 15028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.124 96.456a.181.181 0 1 1-.2-.155.18.18 0 0 1 .2.155",
    "data-name": "Path 15029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.532 96.312a.181.181 0 1 1-.2-.155.18.18 0 0 1 .2.155",
    "data-name": "Path 15030"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49263e",
    d: "M51.713 96.074a.05.05 0 0 1-.047-.008.98.98 0 0 0-.723-.172.051.051 0 0 1-.022-.1 1.07 1.07 0 0 1 .807.191.051.051 0 0 1-.015.089",
    "data-name": "Path 15031"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#49263e",
    d: "M49.444 96.387a.051.051 0 0 1-.057-.079 1.07 1.07 0 0 1 .727-.4.051.051 0 1 1 0 .1.98.98 0 0 0-.651.359.05.05 0 0 1-.025.018",
    "data-name": "Path 15032"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfdfc",
    d: "M51.291 97.919c-.017-.006-1.123-.191-1.123-.191s.073.479.484.549a.67.67 0 0 0 .639-.358",
    "data-name": "Path 15052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#572634",
    d: "M51.367 93.863s-1.555 2.607-3.8 3.036l.371 2.767a3.07 3.07 0 0 1-1.935-2.177c-.337-1.656-.331-4.908 2.475-5.211 2.713-.292 2.887 1.585 2.887 1.585",
    "data-name": "Path 15053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f73",
    d: "M48.297 97.638a.89.89 0 1 1-1-.764.89.89 0 0 1 1 .764",
    "data-name": "Path 15054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f07162",
    d: "M47.423 98.309a.374.374 0 0 1-.387-.231.35.35 0 0 1 .086-.426.42.42 0 0 1 .459-.051.4.4 0 0 0-.2-.182.55.55 0 0 0-.391.027.028.028 0 0 1-.025-.051.6.6 0 0 1 .437-.029.48.48 0 0 1 .27.293l.038.095-.081-.062a.38.38 0 0 0-.47 0 .3.3 0 0 0-.07.359.315.315 0 0 0 .331.2.029.029 0 1 1 .008.056h-.005",
    "data-name": "Path 15055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21111d",
    d: "M58.386 115.152a.08.08 0 0 0 .1-.032l.578-.916-.006-.032-1.564-8.136a4.9 4.9 0 0 0-.9-2.084 7.2 7.2 0 0 0-4.912-2.749.081.081 0 1 0-.027.16 7.04 7.04 0 0 1 4.8 2.676 4.8 4.8 0 0 1 .875 2.018v.006l1.559 8.107-.543.862a.08.08 0 0 0 .025.112l.012.006",
    "data-name": "Path 15058"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9325",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9324"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#market_svg__d)",
    "data-name": "Group 9323",
    transform: "translate(64.9 111.846)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 1.236.087-.001l6.865.482-.087 1.237z",
    "data-name": "Rectangle 2707"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9328",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9327"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#market_svg__e)",
    "data-name": "Group 9326",
    transform: "translate(64.748 113.834)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m0 .359.025-.36L6.89.482l-.025.36z",
    "data-name": "Rectangle 2709"
  })))))))))))));
};
export default SvgMarket;